import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../../actions'
import ActionButton from '../../../common/ActionButton'
import $t from '../../../../i18n'
import {
  getPlansActionAccordingToSubscription,
  isHaveSubscription,
} from '../../../../utils/paymentUtils'
import { getIsHmoMember } from '../../../../utils/hmoUtils'
import config from '../../../../config.json'

import './GetCareSection.css'

const GetCareSection = ({ onScrollToEndPress }) => {
  const dispatch = useDispatch()

  const unreadNotificationCount = useSelector(
    state => state.notifications?.unreadNotificationCount
  )
  const my_subscriptions = useSelector(state => state.payment?.my_subscriptions)
  const isSubscribed = useSelector(state => isHaveSubscription(state))
  const userDetails = useSelector(state => state?.profile?.userDetails)

  const isHmoMember = getIsHmoMember(userDetails)

  const onClinicPress = () => {
    dispatch(Actions.createAction(Actions.SPECIALTY_SERVICES_CLICKED))
  }

  const onGetCarePressed = () => {
    dispatch(Actions.createAction(Actions.PRIMARY_CLINIC_CLICKED))
  }

  const onProviderPressed = () => {
    dispatch(Actions.createAction(Actions.FIND_A_PROVIDER_CLICKED))
  }

  const telehealthActions = [
    {
      text: $t('homeScreen.getCare.primaryCare'),
      image: config.gcpStorageUrl + '/icons/primary-tele.svg',
      onPress: onGetCarePressed,
    },
    {
      text: $t('homeScreen.getCare.healthServices'),
      image: config.gcpStorageUrl + '/icons/healthServices.svg',
      onPress: onClinicPress,
    },
    {
      text: isSubscribed
        ? $t('homeScreen.getCare.paymentDetails')
        : $t('homeScreen.getCare.plans'),
      image: config.gcpStorageUrl + '/icons/plans.svg',
      onPress: () => {
        const action = getPlansActionAccordingToSubscription(my_subscriptions)
        dispatch(action)
      },
    },
  ]

  const hmoActions = [
    {
      text: $t('homeScreen.getCare.seeAClinician'),
      image: config.gcpStorageUrl + '/icons/seeClinician.svg',
      onPress: onGetCarePressed,
    },
    {
      text: $t('homeScreen.essentialActions.provider'),
      image: config.gcpStorageUrl + '/icons/findAProvider.svg',
      onPress: onProviderPressed,
    },
    {
      text: $t('homeScreen.getCare.seeActivity'),
      image: config.gcpStorageUrl + '/icons/activity-big.svg',
      badgedText: unreadNotificationCount,
      onPress: onScrollToEndPress,
    },
  ]

  const getCareActions = isHmoMember ? hmoActions : telehealthActions

  return (
    <div className="get-care-section">
      <div className="section-header">{$t('homeScreen.getCare.title')}</div>
      <div className="get-care-container">
        {getCareActions?.map(action => (
          <ActionButton
            key={action?.text}
            label={action?.text}
            isBadged={!!action?.badgedText}
            badgedText={action?.badgedText}
            image={action?.image}
            isVertical={!isHmoMember}
            size={54}
            className={
              isHmoMember
                ? 'get-care-action hmo-actions trackable'
                : 'get-care-action trackable'
            }
            onPress={action?.onPress}
          />
        ))}
      </div>
    </div>
  )
}

export default GetCareSection
